/**
 * Scan Modal - GitHubScanner in a controlled Dialog
 *
 * @param open - controlled open state
 * @param onOpenChange - open state setter
 */

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/Dialog';
import { GitHubScanner } from '@/components/GitHubScanner';

interface ScanModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Pre-fill the scan target (e.g. when retrying a failed scan). */
  defaultUrl?: string;
}

export function ScanModal({ open, onOpenChange, defaultUrl }: ScanModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-zinc-900 border-zinc-700 p-0 max-h-[90vh] overflow-y-auto">
        <DialogHeader className="sr-only">
          <DialogTitle>Scan GitHub Repository</DialogTitle>
          <DialogDescription>
            Enter a GitHub repository URL to perform a comprehensive security scan.
          </DialogDescription>
        </DialogHeader>
        <GitHubScanner onScanQueued={() => onOpenChange(false)} defaultUrl={defaultUrl} />
      </DialogContent>
    </Dialog>
  );
}
